import { gql } from "@apollo/client";
import { InterviewerForEditorFragment } from "generated/schemaTypes";

export const INTERVIEWER_FOR_EDITOR_FRAGMENT = gql`
  fragment InterviewerForEditorFragment on Interviewer {
    id
    displayFirstName
    displayLastName
    email
    imageUrl
    atsUserId
  }
`;

type Interviewer = InterviewerForEditorFragment;

export default Interviewer;
